/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
/**
 * Component that displays a topological view
 * required params:
 *  - data: object with nodes and links
 *  Example : 
 *  {
        nodes: [{
            id: 1,
            collapsed: true,
            childLinks: [],
            desc: "Description",
        }]
        ,
        links: [{
            source: 1,
            target 2:
        }]
    }
 */

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "../../aframe_components/ForceGraph";

const Topology = React.memo(
    ({
        data,
        nodeColor,
        fontColor,
        dimensions,
        levelDistance,
        dagMode,
        cooldownTime,
        linkDirectionalParticles = 2,
        linkDirectionalParticleWidth,
        linkWidth,
        linkOpacity,
        ...otherAttributes
    }) => {

        useEffect(() => {
            const graphDomNode = ref.current;
            // Add the aframe component to the <a-entity> tag returned by this react component
            const props = {
                nodes: data.nodes,
                links: data.links,
                linkDirectionalArrowLength: 1.5,
                linkDirectionalArrowRelPos: 1,
                linkDirectionalParticles: linkDirectionalParticles,
                linkDirectionalParticleWidth,
                linkDirectionalParticleSpeed: 0.005,
                linkWidth,
                linkOpacity,
                numDimensions: dimensions,
                dagMode,
            };
            if (levelDistance) props.dagLevelDistance = levelDistance;
            if (cooldownTime) props.cooldownTime = cooldownTime;
            if (data.nodeGenerator && graphDomNode) {
                props.nodeThreeObject = (node) => {
                    const domNode = data.nodeGenerator(node);
                    if (!domNode) return;

                    graphDomNode.appendChild(domNode);
                    return domNode.object3D;
                };
                graphDomNode.setAttribute("forcegraph", props);
            }
        });
        const ref = React.createRef();

        return (
            <a-entity class="Topology" {...otherAttributes}>
                <a-entity ref={ref}></a-entity>
            </a-entity>
        );
    }
);

// requiring data
Topology.propTypes = {
    data: PropTypes.object.isRequired
};

export default Topology;
